<div class = "ui-field ui-secondary ui-field-full">
    <div class = "ui-field-label">Tipo de entrega</div>
    @if (options.length) {
        <app-selector icon = "uii-delivery-truck" [value]="currentServiceValue" placeholder="selecione o tipo de entrega" [options] = "options" (changed) = "eventServiceCodeSelection($event)"></app-selector>
    } @else {
        <app-skeleton-loader type="line" viewMode = "horizontal" [size]="1" [width] = "['46rem']"></app-skeleton-loader>
    }
</div>
